const currencies = ['GBP', 'BRL', 'EUR', 'USD', 'COP'];

const currencyFormater = {
  real: {
    decimal: ',',
    thousands: '.',
    precision: 2,
  },

  dolar: {
    decimal: '.',
    thousands: ',',
    precision: 2,
  },

  libra: {
    decimal: '.',
    thousands: ',',
    precision: 2,
  },

  euro: {
    decimal: '.',
    thousands: ',',
    precision: 2,
  },
  cop: {
    decimal: '.',
    thousands: ',',
    precision: 2,
  },
};

export default currencies;
export { currencyFormater };
